export default __webpack_public_path__ + "static/media/icn_healthband_connect.bdb634c9.png";